/**
 * The one holiday-countdown wording rule, shared by every surface that shows
 * "how long until this holiday" (THE-1190). Before this, the Gift guides hub
 * (`hubOccasionSeasonal.occasionCountdownLabel`) and the People page's
 * "Coming up" strip (which gave holiday cards no ladder of their own and
 * reused the person-card one, `ComingUpStrip.formatRelativeDays`) each wrote
 * their own version, so the same holiday read "Next week" on one tab and
 * "In 11 days" on the other.
 *
 * Kate's rule: "Today" and "Tomorrow", then the exact day count up to 2
 * weeks, then whole weeks rounded to the nearest one — never floored, never
 * a "Next week" bucket.
 */
export function holidayCountdownLabel(days: number): string {
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  if (days <= 14) return `In ${days} days`;
  const weeks = Math.round(days / 7);
  return weeks === 1 ? 'In 1 week' : `In ${weeks} weeks`;
}
